let env = {};

env.baseURL = 'https://api.prontidao-hml.ares-despacho.com.br/api/v1/';
env.normalURL = 'https://api.prontidao-hml.ares-despacho.com.br/';
env.wsHost = 'websocket.prontidao-hml.ares-despacho.com.br';
env.wsKey = 'prontidao-hml-key';
env.mode = 'homolog';
env.wsPort = '443';
env.googleApiKey = 'AIzaSyBmngiC-7NbxzKxUzwCE0NfKzWNSDxr9zc';

export default env
